// import urls from "./url";
import axios from "axios";
import store from "@/store/";
// import { jump } from "../utils/common";
// import notification from "ant-design-vue/es/notification";
// import Modal from "ant-design-vue/es/modal";
import { Notify, Dialog, Toast } from "vant";
import $config from "@/config/baseConfig";
import router from "@/router";
import { ls } from "@/utils//cache";
import { USERINFO, RESTARUANTINFO } from "@/store/mutation-types";
import { delUrlParam } from "@/utils/common";
//默认配置
const defaultConfig = {
  serverUrl: $config.http.serverUrl, //请求地址
  responseBody: {
    //http请求响应体
    code: "code",
    data: "data",
    message: "message",
  },
  successCode: 0, // 响应体中 成功状态的 code
};
const config = { ...defaultConfig, ...$config.http };

let modalOpen = false;
//请求状态错误处理
const err = error => {
  if (error.response) {
    const status = error.response.status;
    const data = error.response.data;

    let msg =
      data && data[config.responseBody.message]
        ? data[config.responseBody.message]
        : "";
    if (status === 401) {
      const iswx = (function() {
        return (
          navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
        );
      })();
      if (iswx) {
        if (
          router.currentRoute &&
          router.currentRoute.meta &&
          router.currentRoute.meta.isRestaurant
        ) {
          //餐饮token过期
          const obj = delUrlParam("code");
          const pathName = window.location.pathname;
          //去掉code参数
          window.history.replaceState({}, "", pathName + obj.searchParam);
          const resInfo = ls.get(RESTARUANTINFO);
          store.dispatch("setRestaruantInfo", {});
          store
            .dispatch("getTableToken", {
              ...router.currentRoute.query,
              OldTableId: resInfo.TableId,
              OldCompanyCode: resInfo.CompanyCode,
            })
            .then(() => {
              location.reload();
            });
        } else {
          const obj = delUrlParam("code");
          const pathName = window.location.pathname;
          //去掉code参数重新获取
          window.history.replaceState({}, "", pathName + obj.searchParam);
          store.dispatch("setUserInfo", {});
          store.dispatch("login", { query: { ...obj.queryJson } }).then(res => {
            const info = ls.get(USERINFO);
            const json = {
              Account: info.Account,
              CompanyCode: info.CompanyCode,
            };
            ls.set("LogInfo", json);
            if (res.Data && res.Data.Token) {
              if (res.Data.Token.IsGroupSystem) {
                if (info.fromUrl) {
                  // if (info.fromUrl.includes("order/detail")) {
                  //   const newUrl =
                  //     window.location.host +
                  //     "/groupOrder/page?" +
                  //     info.fromUrl.split("?")[1];
                  //   window.location.href = newUrl;
                  // } else {
                  window.location.href = info.fromUrl;
                  // }
                } else {
                  router.push({ name: "groupIndex" });
                }
              } else {
                if (info.fromUrl) {
                  window.location.href = info.fromUrl;
                } else {
                  router.push({ name: "workplace" });
                }
              }
            } else {
              store.dispatch("logout");
            }
          });
        }
      } else if (!modalOpen) {
        modalOpen = true;
        Dialog.confirm({
          title: "身份令牌已失效",
          message: "您可以取消以停留在此页，或重新登录",
          confirmButtonText: "重新登录",
        })
          .then(() => {
            modalOpen = false;
            store.dispatch("logout");
          })
          .catch(() => {
            modalOpen = false;
          });

        return false;
      }
    } else if (status === 403) {
      msg = "您没有权限";
    } else if (status === 404) {
      msg = "api请求接口不存在";
    } else {
      msg = "请求出错";
    }
    const message =
      data && data[config.responseBody.message]
        ? data[config.responseBody.message]
        : msg;
    Notify(message);
  }
};

//响应体Code异常处理
const abnormal = response => {
  const res = response.data;
  // 当设置 handleError 为 false 则不做异常处理
  if (
    response.config.headers &&
    response.config.headers.handleError === false
  ) {
    return false;
  }

  // const resultCode = res[config.responseBody.code];
  const description =
    res && res[config.responseBody.message]
      ? res[config.responseBody.message]
      : "请求失败";
  // let message = "abnormalCode：" + resultCode;
  // if (resultCode === 99) {
  //   message = "请求参数错误";
  // }
  Notify(description);
};

// 创建实例
const service = axios.create({
  baseURL: config.serverUrl,
  timeout: 30000,
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (config.headers && config.headers.loading === "false") {
      delete config.headers.loading;
    } else {
      Toast.loading({
        duration: 0,
        message: "处理中...",
        forbidClick: true,
      });
    }
    if (
      !(config.data && config.data.notToken) &&
      !(config.params && config.params.notToken) &&
      store.getters.userInfo &&
      store.getters.userInfo.Token &&
      !config.headers["Authorization"]
    ) {
      config.headers["Authorization"] = store.getters.userInfo.Token;
    }
    //餐饮token
    if (
      router.currentRoute &&
      router.currentRoute.meta &&
      router.currentRoute.meta.isRestaurant
    ) {
      if (config.url.includes("GetTableToken")) {
        config.headers["Authorization"] = "";
      } else if (
        store.getters.restaruantInfo &&
        store.getters.restaruantInfo.Token
      ) {
        config.headers["Authorization"] = store.getters.restaruantInfo.Token;
      }
    }
    // config.method = config.method ? config.method : "post";
    config.baseURL = $config.http.serverUrl;
    return config;
  },
  error => {
    Toast.clear();
    err(error);
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    Toast.clear();
    const res = response.data;
    const resultCode = res[config.responseBody.code];
    if (resultCode === config.successCode) {
      return res; // 成功回调
    } else if (resultCode === 98) {
      //夜审冲突时返回Code:98 提示跳转到登录页面
      Dialog.alert({
        message: res.Message ? res.Message : "已进行夜审，请退出重新登录！",
      }).then(() => {
        store.dispatch("logout");
      });
    } else {
      abnormal(response);
      return Promise.reject(new Error(res.Message || "Error"));
    }
  },
  error => {
    Toast.clear();
    err(error);
    return Promise.reject(error);
  },
);

export default service;
